// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
input:-webkit-autofill:focus,
input:-webkit-autofill:hover,
input:-webkit-autofill:active {
  box-shadow: 0 0 0px 1000px #f2f6fa inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #f2f6fa inset !important;
  background-color: #f2f6fa !important;
  color: #263e57 !important;
  border-radius: 8px !important;
  font-family: 'Poppins', sans-serif;
  height: 45px;
  padding: 0%;
}
.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border: rgba(70, 128, 255, 0.1);
  box-shadow: 0 0 0 2px rgba(70, 128, 255, 0.1);
}

.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  transition: border-color 0s;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;EAIE,mDAAmD;EACnD,2DAA2D;EAC3D,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;EAClC,YAAY;EACZ,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["input:-webkit-autofill,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:active {\n  box-shadow: 0 0 0px 1000px #f2f6fa inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #f2f6fa inset !important;\n  background-color: #f2f6fa !important;\n  color: #263e57 !important;\n  border-radius: 8px !important;\n  font-family: 'Poppins', sans-serif;\n  height: 45px;\n  padding: 0%;\n}\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border: rgba(70, 128, 255, 0.1);\n  box-shadow: 0 0 0 2px rgba(70, 128, 255, 0.1);\n}\n\n.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  transition: border-color 0s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
